import {faStar} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import React from 'react'

interface MemberRateBadgeProps {
  className?: string
}

const MemberRateBadge: React.FC<MemberRateBadgeProps> = ({className}) => {
  return (
    <div
      className={clsx(
        'badge badge-outline badge-accent rounded-full font-medium px-1.5',
        className
      )}
    >
      <FontAwesomeIcon
        icon={faStar}
        className="mr-1 mb-[1px] text-2xs"
        title="Member rate"
      />
      <span className="text-xs">Insider Rate</span>
    </div>
  )
}

export default MemberRateBadge
